import { useEffect } from 'react';

const useOutsideClick = (ref, listener) => {
  useEffect(() => {
    const documentClickHandler = e => {
      if (ref.current && !ref.current.contains(e.target)) {
        return listener(e);
      }
    };

    document.addEventListener('click', documentClickHandler);
    return () => document.removeEventListener('click', documentClickHandler);
  }, [ref, listener]);
};

export default useOutsideClick;
